import styled from "styled-components";
const img = require("../../assets/img/notFound.png");

export const Img = styled.div`
width: 100%;
height: 100vh;

background-image: url(${img});

background-size: contain ;
background-repeat: no-repeat ;
background-position: center ;
`